module.exports = __webpack_public_path__ + "media/images/logo-white-ae9573da81e29da6ba5b261ae5bf8b43.svg";